import React from 'react';
import '../App.css';

interface LabelProps {
    children: React.ReactNode;
    htmlFor?: string;
    className?: string;
}

const SectionLabel: React.FC<LabelProps> = ({ children, className = '', htmlFor }) => {
    return (
        <label htmlFor={htmlFor} className={`sectionlabel ${className}`}>
            {children}
        </label>
    );
};

export default SectionLabel;
